import Input from './Input';

export { default as Select } from './Select';
export { default as TextArea } from './TextArea';

export default Input;
